require("./ynet_site_newsflashShareMenu.less")
import { openFacebookShare, openTwitterShare, analyticsPushFunc } from "../../../../../widgetsUtils";
import { MailShareButton } from "widgets/siteWidgets/socialShareButtons/mail/mailShareButton";
import { WhatsAppShareButton } from "../../../../../siteWidgets/socialShareButtons/whatsApp/whatsAppShareButton";
import { getTranslation } from "../../../autoTickerRowWidget/autoTickerRowTranslations";
const clickOutside = require('react-click-outside');

interface NewsFlashShareMenuProps {
    title: string
    shareUrl: string
    isNew?: boolean
    articleId?: string
    className?: string
    isMobileWeb?: boolean
}

interface NewsFlashShareMenuState {
    isMenuOpened: boolean
}

declare let window: Window & {
    languageCode: string
}

@clickOutside
export class NewsFlashShareMenu extends React.Component<NewsFlashShareMenuProps, NewsFlashShareMenuState> {

    constructor(props) {
        super(props);
        this.state = {
            isMenuOpened: false
        };
    }

    private handleShareBtnClick = (button: string) => {
        if (typeof window !== "undefined") {
            const current_url = this.props.shareUrl;
            const { title, isNew } = this.props;
            const current_article_id = this.props.articleId ? this.props.articleId : null;

            switch (button) {
                case "fb":
                    openFacebookShare(current_url, "", isNew ? () => analyticsPushFunc("Facebook", "Share", title) : () => analyticsPushFunc("Share News Flash", "News Flash Tab", "Facebook"), "Flash", current_article_id)
                    break;

                case "tw":
                    openTwitterShare(current_url, isNew ? () => analyticsPushFunc("Twitter", "Share", title) : () => analyticsPushFunc("Share News Flash", "News Flash Tab", "Twitter"), "Flash", current_article_id)
                    break;

                case "mailto":
                    MailShareButton.openMailShare(title, current_url, "heFlash", isNew ? () => analyticsPushFunc("Mail", "Share", title) : () => analyticsPushFunc("Share News Flash", "News Flash Tab", "Mail"), "Flash", current_article_id)
                    break;

                case "wa":
                    WhatsAppShareButton.openWhatsAppShare(current_url, isNew ? () => analyticsPushFunc("Whatsapp", "Share", title) : () => analyticsPushFunc("Share News Flash", "News Flash Tab", "Whatsapp"), "Flash", current_article_id)
                    break;
            }
        }
    }

    private openNativeShare = async () => {
        const { title, shareUrl } = this.props;
        const shareData = { url: shareUrl, title: title }

        try {
            // @ts-ignore 
            await navigator.share(shareData)
            document.dispatchEvent(new CustomEvent("newsFlashesTwentyFourSevenShare", { detail: { label: title } }))
        } catch (err) {
            console.log("error with sharing function", err);
        }
    }

    private handleShareMenuBtnClick = (e) => {
        const { isMobileWeb } = this.props;

        e.stopPropagation();
        if (isMobileWeb) {
            this.openNativeShare();
        } else {
            this.setState({ isMenuOpened: !this.state.isMenuOpened });
        }
    }

    render() {
        const { isMenuOpened } = this.state;
        const { isMobileWeb, className } = this.props
        const lang = typeof window != "undefined" && window.languageCode.slice(0, 2) ? window.languageCode.slice(0, 2) : "he";
        const textMail = getTranslation(lang, "ShareByMail");
        const textTw = getTranslation(lang, "ShareByTwitter");
        const textFb = getTranslation(lang, "ShareByFacebook");
        const textWa = getTranslation(lang, "ShareByWhatsApp");

        return isMobileWeb ?
            <div className={`mobile-share-btn ${className ? className : ""}`} onClick={e => this.handleShareMenuBtnClick(e)}></div>
            :
            <div className={`newsflash-share-menu ${isMenuOpened ? "opened" : ""} ${className ? className : ""}`}>
                <button title={textWa} className="shareIcon1280 wa" onClick={e => this.handleShareBtnClick("wa")}></button>

                <div className="desktop-menu-icon" onClick={this.handleShareMenuBtnClick}></div>

                <div className="desktop-share-btns">
                    <button title={textFb} className="shareIcon1280 fb" onClick={e => this.handleShareBtnClick("fb")}></button>
                    <button title={textTw} className="shareIcon1280 tw" onClick={e => this.handleShareBtnClick("tw")}></button>
                    <button title={textMail} className="shareIcon1280 mailto" onClick={e => this.handleShareBtnClick("mailto")}></button>
                </div>
            </div>
    }
}
